import JobList from "../components/JobList";
import TopBar from "../components/TopBar";

const Home = () => {
    return (
        <>
            <TopBar />
            <JobList />
        </>
    );
};

export default Home;
